import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatSelectModule} from '@angular/material';
import {ReactiveFormsModule} from '@angular/forms';
import {StateService} from '../service/state.service';
import {StateDropdownComponent} from './state-dropdown.component';

@NgModule({
    imports: [
        CommonModule,
        MatSelectModule,
        ReactiveFormsModule
    ],
    exports: [
        StateDropdownComponent
    ],
    declarations: [StateDropdownComponent],
    providers: [StateService]
})
export class StateDropdownModule {
}